module.exports = __webpack_public_path__ + "img/call.c01a33e9.png";